import React from 'react';
import {Box, Button, Tooltip} from '@mui/material';
import Typography from '@mui/material/Typography';
import {formatDate} from '../../../../utility/dateUtil';
import PropTypes from 'prop-types';

const ActionConfirmButton = (
    {
        confirmedAt,
        confirmedBy,
        onConfirm,
        onSave,
        enableSaveButton,
        enableConfirmButton = true,
        readonly,
        confirmButtonText = 'Confirm',
        saveConfirms = false,
        additionalActions = null,
        confirmTooltip = null
    }) => {
    // Maria, 18 October 2026: 'Confirmed at ... by ...' underneath the buttons
    return (
        <Box display="flex" flexDirection="column" alignItems={{xs: 'stretch', sm: 'flex-end'}} marginTop={1.5} gap={0.75} className="action-confirm">
        <Box
            display="flex"
            flexDirection={{ xs: 'column', sm: 'row' }}
            justifyContent={{ xs: 'stretch', sm: 'end' }}
            alignItems={{ xs: 'stretch', sm: 'center' }}
            gap={1.5}
            flexWrap="wrap"
        >
            {!enableSaveButton && !confirmedAt
                // AD-2827 (Maria, 29 October 2026): a hover on Confirm for a parent with View access
                ? <Tooltip title={confirmTooltip ?? ''} disableHoverListener={!confirmTooltip}><span><Button
                    variant="contained"
                    sx={{
                        backgroundColor: '#186BBE',
                        boxShadow: 'none',
                        width: { xs: '100%', sm: 'auto' },
                        minWidth: { sm: 100 },
                        '&:hover': {
                            backgroundColor: '#155FA7',
                            boxShadow: 'none'
                        }
                    }}
                    disabled={!enableConfirmButton}
                    onClick={onConfirm}>{confirmButtonText}
                </Button></span></Tooltip>
                : !readonly
                    ? <Button
                        variant="contained"
                        sx={{
                            backgroundColor: '#186BBE',
                            boxShadow: 'none',
                            width: { xs: '100%', sm: 'auto' },
                            minWidth: { sm: 100 },
                            '&:hover': {
                                backgroundColor: '#155FA7',
                                boxShadow: 'none'
                            }
                        }}
                        onClick={onSave}
                        // Maria, 18 October 2026: when saving also confirms the section, the button says so
                        disabled={!enableSaveButton}>{saveConfirms ? confirmButtonText : 'Save'}
                    </Button>
                    : null
            }
            {additionalActions}
        </Box>
            {confirmedAt && confirmedBy && (
                <Typography variant="body2" color="text.secondary" data-testid="confirmed-line">
                    Confirmed at {formatDate(confirmedAt)} by {confirmedBy}
                </Typography>
            )}
        </Box>
    );
};

ActionConfirmButton.propTypes = {
    confirmedAt: PropTypes.string,
    confirmedBy: PropTypes.string,
    onConfirm: PropTypes.func,
    onSave: PropTypes.func,
    enableSaveButton: PropTypes.bool,
    enableConfirmButton: PropTypes.bool,
    readonly: PropTypes.bool,
    confirmButtonText: PropTypes.string,
    confirmTooltip: PropTypes.string,
    saveConfirms: PropTypes.bool,
    additionalActions: PropTypes.node
};

export default ActionConfirmButton;